import styled from 'styled-components/macro';


const ContainerDiv = styled.div`
    width: 100vw;
    height: -webkit-fill-available;
    min-height: 100vh;
    display: flex;
    flex-direction: row;
    overflow: hidden;
`

export default ContainerDiv